// Thin GA4 wrapper: no-ops when gtag isn't loaded (dev, blockers, SSR).
export function track(event, params = {}) {
  try {
    if (typeof window !== "undefined" && typeof window.gtag === "function") window.gtag("event", event, params);
  } catch {
    /* analytics must never break the page */
  }
}
